import angular from "angular";

angular
    .module('app')
    .component('lessonComments', {
        template: require('./lesson-comments.html'),
        controller: ['$uibModal', 'Auth', '$http', 'Notifier', '$timeout', 'trans', '$document', 'moment', controller],
        bindings: {
            course: '<',
            lesson: '<',
            inputId: '<',
        }
    });

function controller($uibModal, Auth, $http, Notifier, $timeout, trans, $document, moment) {

    let $ctrl = this;

    $ctrl.text = null;

    $ctrl.$onInit = function () {


        $ctrl.getLessonComments();

        if ($ctrl.inputId) {
            $timeout(function () {
                for (let i = 0; i < $ctrl.comments.length; i++) {
                    if ($ctrl.comments[i].id == $ctrl.inputId) {
                        $ctrl.goToComment($ctrl.comments[i]);
                        break;
                    }
                }
            }, 1000)
        }

    };

    $ctrl.getLessonComments = function () {
        $http.get(`/cabinet/courses/${$ctrl.course.id}/lessons/${$ctrl.lesson.id}/get-comments`)
            .then(function (response) {
                $ctrl.comments = response.data;

                reset();
            },function (error) {

            })
    };

    function reset() {

        for (let i = 0; i < $ctrl.comments.length; i++) {
            $ctrl.comments[i].ind = i + 1;
        }

        for (let i = 0; i < $ctrl.comments.length; i++) {
            for (let j = 0; j < $ctrl.comments.length; j++) {
                if (i != j) {
                    let a = $ctrl.comments[i];
                    let b = $ctrl.comments[j];
                    if (a.parent_id == b.id) {
                        a.parent = b;
                    }
                }
            }
        }

        $ctrl.rootComments = $ctrl.comments.filter(v => !v.parent_id);

        $ctrl.rootComments.forEach(function (comment) {

            comment.childComments = [];

            for (let i = 0; i < $ctrl.comments.length; i++) {

                let k = $ctrl.comments[i];

                if (!k.parent_id) {
                    continue;
                }

                if (k.parent_id == comment.id) {
                    comment.childComments.push($ctrl.comments[i]);

                } else {
                    let hasParentInChild = false;

                    for (let j = 0; j < comment.childComments.length; j++) {
                        if (comment.childComments[j].id == k.parent_id) {
                            hasParentInChild = true;
                            break;
                        }
                    }

                    if (hasParentInChild) {
                        comment.childComments.push(k);
                    }
                }
            }
        });

    }

    $ctrl.create = function () {

        $ctrl.loading = true;

        let params = {
            course_id: $ctrl.course.id,
            lesson_id: $ctrl.lesson.id,
            text: $ctrl.text,
        };

        $http
            .post(`/cabinet/courses/${$ctrl.course.id}/lessons/${$ctrl.lesson.id}/add-comment`, params)
            .then(
                function (response) {

                    $ctrl.loading = false;

                    let comment = {
                        id: response.data.id,
                        text: $ctrl.text,
                        user: Auth.user(),
                        is_own: true,
                        created_at: moment(),
                        ind: $ctrl.comments.length + 1,
                        course_id: $ctrl.course.id,
                        lesson_id: $ctrl.lesson.id,
                        childComments: [],
                    };

                    $ctrl.comments.push(comment);

                    $ctrl.rootComments.push(comment);

                    Notifier.success(trans('Your comment success added'), 3);

                    $timeout(function () {
                        $ctrl.goToComment(comment);
                    }, 500);

                    $ctrl.text = null;
                },
                function (error) {
                    $ctrl.loading = false;
                    Notifier.error(error.data.message);
                }
            );
    };

    $ctrl.goToComment = function (comment) {

        comment.isActive = true;

        $timeout(function () {
            comment.isActive = false;
        }, 2500);

        let el = window.angular.element(window.document.getElementById('comment_' + comment.id));

        $document.scrollTo(el, 20);
    };

    $ctrl.openEditForm = function (comment) {
        $uibModal.open({
            component: 'commentForm',
            resolve: {
                comment: function () {
                    return comment;
                },
                lesson: function () {
                    return $ctrl.lesson;
                },
                course: function () {
                    return $ctrl.course;
                }
            }
        });
    };

    $ctrl.delete = function (comment, ind, parentComment) {

        if (comment.deleteLoading) {
            return;
        }

        if (!confirm(trans('Are you confirm do this action?'))) {
            return;
        }

        comment.deleteLoading = true;

        $http
            .delete(`/cabinet/courses/${$ctrl.course.id}/lessons/${$ctrl.lesson.id}/comments/${comment.id}/delete-comment`)
            .then(
                function (response) {
                    if (response.data.has_child_comments) {
                        comment.is_deleted = true;
                    } else {
                        if (parentComment) {
                            parentComment.childComments.splice(ind, 1);
                        } else {
                            $ctrl.rootComments.splice(ind, 1);
                        }
                    }

                    Notifier.success(trans('Comment success deleted'), 2);
                },
                function (error) {
                    Notifier.error(error.data.message, 2);
                    comment.deleteLoading = false;
                }
            );
    };

    $ctrl.replyForComment = function (comment) {
        $uibModal
            .open({
                component: 'commentReplyForm',
                resolve: {
                    comment: function () {
                        return comment;
                    }
                }
            })
            .result
            .then(
                function (replyComment) {

                    $ctrl.comments.push(replyComment);

                    replyComment.ind = $ctrl.comments.length;
                    replyComment.parent = comment;

                    let parentComment = comment;

                    while (true) {
                        if (parentComment.parent) {
                            parentComment = parentComment.parent;
                        } else {
                            break;
                        }
                    }

                    parentComment.childComments.push(replyComment);

                    $timeout(function () {
                        $ctrl.goToComment(replyComment);
                    }, 500);
                },
                function () {
                }
            );
    };

}
